import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-picture',
  templateUrl: './update-picture.component.html',
  styleUrls: ['./update-picture.component.css']
})
export class UpdatePictureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
